import { render, staticRenderFns } from "./TopLectures.vue?vue&type=template&id=10fef6d9&"
import script from "./TopLectures.vue?vue&type=script&lang=js&"
export * from "./TopLectures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports